/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ResourceAffectedResponse } from '../models/resource-affected-response';
import { AffectedResourcesRequest } from '../models/affected-resources-request';
import { BlueprintFile } from '../models/blueprint-file';
import { JsonNode } from '../models/json-node';
import { RBACEntity } from '../models/rbacentity';
import { StackGitLog } from '../models/stack-git-log';
import { ClusterResourcesResponse } from '../models/cluster-resources-response';
import { ServiceOverview } from '../models/service-overview';
import { AllRegionsAndAZ } from '../models/all-regions-and-az';
import { OutputReference } from '../models/output-reference';
import { ResourceHistory } from '../models/resource-history';
import { ResourceHistoryOverview } from '../models/resource-history-overview';

/**
 * Ui Dropdowns Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiDropdownsControllerService extends __BaseService {
  static readonly getAffectedResourcesByClusterUsingPOSTPath =
    '/cc-ui/v1/dropdown/cluster/{clusterId}/affected-resources';
  static readonly getAllResourcesUsingGETPath =
    '/cc-ui/v1/dropdown/cluster/{clusterId}/resources';
  static readonly getAllResourcesByClusterUsingGETPath =
    '/cc-ui/v1/dropdown/cluster/{clusterId}/resources-info';
  static readonly getResourceByClusterIdUsingGETPath =
    '/cc-ui/v1/dropdown/cluster/{clusterId}/{resourceType}/{resourceName}/resource-info';
  static readonly getFileFromFacetsModulesUsingGETPath =
    '/cc-ui/v1/dropdown/file';
  static readonly getAllPermissionsUsingGETPath =
    '/cc-ui/v1/dropdown/getAllPermissions';
  static readonly syncClusterHistoryUsingPOSTPath =
    '/cc-ui/v1/dropdown/logs/cluster/{clusterId}';
  static readonly getGitHistoryForResourceUsingGETPath =
    '/cc-ui/v1/dropdown/logs/cluster/{clusterId}/resourceName/{resourceName}/resourceType/{resourceType}';
  static readonly syncSubstackGitHistoryUsingPOSTPath =
    '/cc-ui/v1/dropdown/logs/substack';
  static readonly getReleaseStreamsUsingGETPath =
    '/cc-ui/v1/dropdown/releaseStreams';
  static readonly getRolePermissionsUsingGETPath =
    '/cc-ui/v1/dropdown/rolePermissions/{role}';
  static readonly getAffectedResourcesByStackUsingPOSTPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/affected-resources';
  static readonly getAllResourcesForAllClusterOfStackUsingGETPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/all-cluster-resources';
  static readonly getAllResourcesByStackUsingGETPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/resources-info';
  static readonly getServiceOverviewUsingGETPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/service/{serviceName}/overview';
  static readonly getAllClusterResourcesByStackUsingGETPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/{resourceType}/{resourceName}/cluster-resources-info';
  static readonly getResourceByStackUsingGETPath =
    '/cc-ui/v1/dropdown/stack/{stackName}/{resourceType}/{resourceName}/resource-info';
  static readonly getAllVCSUsingGETPath = '/cc-ui/v1/dropdown/vcs';
  static readonly getAzForRegionByCloudUsingGETPath =
    '/cc-ui/v1/dropdown/{cloud}/region/{region}/availability-zones';
  static readonly getRegionsUsingGETPath = '/cc-ui/v1/dropdown/{cloud}/regions';
  static readonly getRegionsV2UsingGETPath =
    '/cc-ui/v1/dropdown/{cloud}/regions-v2';
  static readonly getLaunchDAGUsingGETPath =
    '/cc-ui/v1/dropdown/{clusterId}/cloud/{cloud}/launch-dag';
  static readonly getApplicationListByClusterIdAndResourceNameUsingGETPath =
    '/cc-ui/v1/dropdown/{clusterId}/{resourceType}';
  static readonly getOutputReferencesUsingGETPath =
    '/cc-ui/v1/dropdown/{stackName}/output/{outputType}/references';
  static readonly getResourceHistoriesByStackUsingGETPath =
    '/cc-ui/v1/dropdown/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/resource-history';
  static readonly getResourceHistoryOverviewByStackUsingGETPath =
    '/cc-ui/v1/dropdown/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/resource-history-overview';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAffectedResourcesByCluster
   * @param params The `UiDropdownsControllerService.GetAffectedResourcesByClusterUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getAffectedResourcesByClusterUsingPOSTResponse(
    params: UiDropdownsControllerService.GetAffectedResourcesByClusterUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ResourceAffectedResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.request;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/dropdown/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/affected-resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceAffectedResponse>;
      }),
    );
  }
  /**
   * getAffectedResourcesByCluster
   * @param params The `UiDropdownsControllerService.GetAffectedResourcesByClusterUsingPOSTParams` containing the following parameters:
   *
   * - `request`: request
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getAffectedResourcesByClusterUsingPOST(
    params: UiDropdownsControllerService.GetAffectedResourcesByClusterUsingPOSTParams,
  ): __Observable<ResourceAffectedResponse> {
    return this.getAffectedResourcesByClusterUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ResourceAffectedResponse),
    );
  }

  /**
   * getAllResources
   * @param params The `UiDropdownsControllerService.GetAllResourcesUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `excludeSubstackResources`: excludeSubstackResources
   *
   * @return OK
   */
  getAllResourcesUsingGETResponse(
    params: UiDropdownsControllerService.GetAllResourcesUsingGETParams,
  ): __Observable<__StrictHttpResponse<{ [key: string]: Array<string> }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.excludeSubstackResources != null)
      __params = __params.set(
        'excludeSubstackResources',
        params.excludeSubstackResources.toString(),
      );
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{ [key: string]: Array<string> }>;
      }),
    );
  }
  /**
   * getAllResources
   * @param params The `UiDropdownsControllerService.GetAllResourcesUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `excludeSubstackResources`: excludeSubstackResources
   *
   * @return OK
   */
  getAllResourcesUsingGET(
    params: UiDropdownsControllerService.GetAllResourcesUsingGETParams,
  ): __Observable<{ [key: string]: Array<string> }> {
    return this.getAllResourcesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as { [key: string]: Array<string> }),
    );
  }

  /**
   * getAllResourcesByCluster
   * @param params The `UiDropdownsControllerService.GetAllResourcesByClusterUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `includeSubstack`: includeSubstack
   *
   * - `includeContent`: includeContent
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * @return OK
   */
  getAllResourcesByClusterUsingGETResponse(
    params: UiDropdownsControllerService.GetAllResourcesByClusterUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<BlueprintFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.includeSubstack != null)
      __params = __params.set(
        'includeSubstack',
        params.includeSubstack.toString(),
      );
    if (params.includeContent != null)
      __params = __params.set(
        'includeContent',
        params.includeContent.toString(),
      );
    if (params.excludeAddOns != null)
      __params = __params.set('excludeAddOns', params.excludeAddOns.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/resources-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BlueprintFile>>;
      }),
    );
  }
  /**
   * getAllResourcesByCluster
   * @param params The `UiDropdownsControllerService.GetAllResourcesByClusterUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `includeSubstack`: includeSubstack
   *
   * - `includeContent`: includeContent
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * @return OK
   */
  getAllResourcesByClusterUsingGET(
    params: UiDropdownsControllerService.GetAllResourcesByClusterUsingGETParams,
  ): __Observable<Array<BlueprintFile>> {
    return this.getAllResourcesByClusterUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<BlueprintFile>),
    );
  }

  /**
   * getResourceByClusterId
   * @param params The `UiDropdownsControllerService.GetResourceByClusterIdUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * - `includeContent`: includeContent
   *
   * @return OK
   */
  getResourceByClusterIdUsingGETResponse(
    params: UiDropdownsControllerService.GetResourceByClusterIdUsingGETParams,
  ): __Observable<__StrictHttpResponse<BlueprintFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.includeContent != null)
      __params = __params.set(
        'includeContent',
        params.includeContent.toString(),
      );
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/${encodeURIComponent(
          String(params.resourceType),
        )}/${encodeURIComponent(String(params.resourceName))}/resource-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BlueprintFile>;
      }),
    );
  }
  /**
   * getResourceByClusterId
   * @param params The `UiDropdownsControllerService.GetResourceByClusterIdUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * - `includeContent`: includeContent
   *
   * @return OK
   */
  getResourceByClusterIdUsingGET(
    params: UiDropdownsControllerService.GetResourceByClusterIdUsingGETParams,
  ): __Observable<BlueprintFile> {
    return this.getResourceByClusterIdUsingGETResponse(params).pipe(
      __map((_r) => _r.body as BlueprintFile),
    );
  }

  /**
   * getFileFromFacetsModules
   * @param params The `UiDropdownsControllerService.GetFileFromFacetsModulesUsingGETParams` containing the following parameters:
   *
   * - `path`: path
   *
   * - `fileName`: fileName
   *
   * @return OK
   */
  getFileFromFacetsModulesUsingGETResponse(
    params: UiDropdownsControllerService.GetFileFromFacetsModulesUsingGETParams,
  ): __Observable<__StrictHttpResponse<JsonNode>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.path != null)
      __params = __params.set('path', params.path.toString());
    if (params.fileName != null)
      __params = __params.set('fileName', params.fileName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/dropdown/file`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<JsonNode>;
      }),
    );
  }
  /**
   * getFileFromFacetsModules
   * @param params The `UiDropdownsControllerService.GetFileFromFacetsModulesUsingGETParams` containing the following parameters:
   *
   * - `path`: path
   *
   * - `fileName`: fileName
   *
   * @return OK
   */
  getFileFromFacetsModulesUsingGET(
    params: UiDropdownsControllerService.GetFileFromFacetsModulesUsingGETParams,
  ): __Observable<JsonNode> {
    return this.getFileFromFacetsModulesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as JsonNode),
    );
  }

  /**
   * getAllPermissions
   * @return OK
   */
  getAllPermissionsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<RBACEntity>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/dropdown/getAllPermissions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RBACEntity>>;
      }),
    );
  }
  /**
   * getAllPermissions
   * @return OK
   */
  getAllPermissionsUsingGET(): __Observable<Array<RBACEntity>> {
    return this.getAllPermissionsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<RBACEntity>),
    );
  }

  /**
   * syncClusterHistory
   * @param params The `UiDropdownsControllerService.SyncClusterHistoryUsingPOSTParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `force`: force
   */
  syncClusterHistoryUsingPOSTResponse(
    params: UiDropdownsControllerService.SyncClusterHistoryUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.force != null)
      __params = __params.set('force', params.force.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/dropdown/logs/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncClusterHistory
   * @param params The `UiDropdownsControllerService.SyncClusterHistoryUsingPOSTParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `force`: force
   */
  syncClusterHistoryUsingPOST(
    params: UiDropdownsControllerService.SyncClusterHistoryUsingPOSTParams,
  ): __Observable<null> {
    return this.syncClusterHistoryUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getGitHistoryForResource
   * @param params The `UiDropdownsControllerService.GetGitHistoryForResourceUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getGitHistoryForResourceUsingGETResponse(
    params: UiDropdownsControllerService.GetGitHistoryForResourceUsingGETParams,
  ): __Observable<__StrictHttpResponse<StackGitLog>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/logs/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/resourceType/${encodeURIComponent(String(params.resourceType))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<StackGitLog>;
      }),
    );
  }
  /**
   * getGitHistoryForResource
   * @param params The `UiDropdownsControllerService.GetGitHistoryForResourceUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getGitHistoryForResourceUsingGET(
    params: UiDropdownsControllerService.GetGitHistoryForResourceUsingGETParams,
  ): __Observable<StackGitLog> {
    return this.getGitHistoryForResourceUsingGETResponse(params).pipe(
      __map((_r) => _r.body as StackGitLog),
    );
  }

  /**
   * syncSubstackGitHistory
   * @param params The `UiDropdownsControllerService.SyncSubstackGitHistoryUsingPOSTParams` containing the following parameters:
   *
   * - `substackName`: substackName
   *
   * - `forceSync`: forceSync
   */
  syncSubstackGitHistoryUsingPOSTResponse(
    params: UiDropdownsControllerService.SyncSubstackGitHistoryUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.substackName != null)
      __params = __params.set('substackName', params.substackName.toString());
    if (params.forceSync != null)
      __params = __params.set('forceSync', params.forceSync.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/dropdown/logs/substack`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * syncSubstackGitHistory
   * @param params The `UiDropdownsControllerService.SyncSubstackGitHistoryUsingPOSTParams` containing the following parameters:
   *
   * - `substackName`: substackName
   *
   * - `forceSync`: forceSync
   */
  syncSubstackGitHistoryUsingPOST(
    params: UiDropdownsControllerService.SyncSubstackGitHistoryUsingPOSTParams,
  ): __Observable<null> {
    return this.syncSubstackGitHistoryUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getReleaseStreams
   * @return OK
   */
  getReleaseStreamsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<string>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/dropdown/releaseStreams`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getReleaseStreams
   * @return OK
   */
  getReleaseStreamsUsingGET(): __Observable<Array<string>> {
    return this.getReleaseStreamsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getRolePermissions
   * @param role role
   * @return OK
   */
  getRolePermissionsUsingGETResponse(
    role: string,
  ): __Observable<__StrictHttpResponse<Array<RBACEntity>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/rolePermissions/${encodeURIComponent(
          String(role),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<RBACEntity>>;
      }),
    );
  }
  /**
   * getRolePermissions
   * @param role role
   * @return OK
   */
  getRolePermissionsUsingGET(role: string): __Observable<Array<RBACEntity>> {
    return this.getRolePermissionsUsingGETResponse(role).pipe(
      __map((_r) => _r.body as Array<RBACEntity>),
    );
  }

  /**
   * getAffectedResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAffectedResourcesByStackUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `request`: request
   *
   * @return OK
   */
  getAffectedResourcesByStackUsingPOSTResponse(
    params: UiDropdownsControllerService.GetAffectedResourcesByStackUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<ResourceAffectedResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/affected-resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceAffectedResponse>;
      }),
    );
  }
  /**
   * getAffectedResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAffectedResourcesByStackUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `request`: request
   *
   * @return OK
   */
  getAffectedResourcesByStackUsingPOST(
    params: UiDropdownsControllerService.GetAffectedResourcesByStackUsingPOSTParams,
  ): __Observable<ResourceAffectedResponse> {
    return this.getAffectedResourcesByStackUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as ResourceAffectedResponse),
    );
  }

  /**
   * getAllResourcesForAllClusterOfStack
   * @param params The `UiDropdownsControllerService.GetAllResourcesForAllClusterOfStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * @return OK
   */
  getAllResourcesForAllClusterOfStackUsingGETResponse(
    params: UiDropdownsControllerService.GetAllResourcesForAllClusterOfStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ClusterResourcesResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.excludeAddOns != null)
      __params = __params.set('excludeAddOns', params.excludeAddOns.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/all-cluster-resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ClusterResourcesResponse>>;
      }),
    );
  }
  /**
   * getAllResourcesForAllClusterOfStack
   * @param params The `UiDropdownsControllerService.GetAllResourcesForAllClusterOfStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * @return OK
   */
  getAllResourcesForAllClusterOfStackUsingGET(
    params: UiDropdownsControllerService.GetAllResourcesForAllClusterOfStackUsingGETParams,
  ): __Observable<Array<ClusterResourcesResponse>> {
    return this.getAllResourcesForAllClusterOfStackUsingGETResponse(
      params,
    ).pipe(__map((_r) => _r.body as Array<ClusterResourcesResponse>));
  }

  /**
   * getAllResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAllResourcesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `includeContent`: includeContent
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * - `branch`: branch
   *
   * @return OK
   */
  getAllResourcesByStackUsingGETResponse(
    params: UiDropdownsControllerService.GetAllResourcesByStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<BlueprintFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.includeContent != null)
      __params = __params.set(
        'includeContent',
        params.includeContent.toString(),
      );
    if (params.excludeAddOns != null)
      __params = __params.set('excludeAddOns', params.excludeAddOns.toString());
    if (params.branch != null)
      __params = __params.set('branch', params.branch.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/resources-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BlueprintFile>>;
      }),
    );
  }
  /**
   * getAllResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAllResourcesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `includeContent`: includeContent
   *
   * - `excludeAddOns`: excludeAddOns
   *
   * - `branch`: branch
   *
   * @return OK
   */
  getAllResourcesByStackUsingGET(
    params: UiDropdownsControllerService.GetAllResourcesByStackUsingGETParams,
  ): __Observable<Array<BlueprintFile>> {
    return this.getAllResourcesByStackUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<BlueprintFile>),
    );
  }

  /**
   * getServiceOverview
   * @param params The `UiDropdownsControllerService.GetServiceOverviewUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `serviceName`: serviceName
   *
   * @return OK
   */
  getServiceOverviewUsingGETResponse(
    params: UiDropdownsControllerService.GetServiceOverviewUsingGETParams,
  ): __Observable<__StrictHttpResponse<ServiceOverview>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/service/${encodeURIComponent(String(params.serviceName))}/overview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ServiceOverview>;
      }),
    );
  }
  /**
   * getServiceOverview
   * @param params The `UiDropdownsControllerService.GetServiceOverviewUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `serviceName`: serviceName
   *
   * @return OK
   */
  getServiceOverviewUsingGET(
    params: UiDropdownsControllerService.GetServiceOverviewUsingGETParams,
  ): __Observable<ServiceOverview> {
    return this.getServiceOverviewUsingGETResponse(params).pipe(
      __map((_r) => _r.body as ServiceOverview),
    );
  }

  /**
   * getAllClusterResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAllClusterResourcesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getAllClusterResourcesByStackUsingGETResponse(
    params: UiDropdownsControllerService.GetAllClusterResourcesByStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<BlueprintFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(
          String(params.resourceType),
        )}/${encodeURIComponent(
          String(params.resourceName),
        )}/cluster-resources-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BlueprintFile>>;
      }),
    );
  }
  /**
   * getAllClusterResourcesByStack
   * @param params The `UiDropdownsControllerService.GetAllClusterResourcesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getAllClusterResourcesByStackUsingGET(
    params: UiDropdownsControllerService.GetAllClusterResourcesByStackUsingGETParams,
  ): __Observable<Array<BlueprintFile>> {
    return this.getAllClusterResourcesByStackUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<BlueprintFile>),
    );
  }

  /**
   * getResourceByStack
   * @param params The `UiDropdownsControllerService.GetResourceByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `branch`: branch
   *
   * @return OK
   */
  getResourceByStackUsingGETResponse(
    params: UiDropdownsControllerService.GetResourceByStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<BlueprintFile>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.branch != null)
      __params = __params.set('branch', params.branch.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/stack/${encodeURIComponent(
          String(params.stackName),
        )}/${encodeURIComponent(
          String(params.resourceType),
        )}/${encodeURIComponent(String(params.resourceName))}/resource-info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<BlueprintFile>;
      }),
    );
  }
  /**
   * getResourceByStack
   * @param params The `UiDropdownsControllerService.GetResourceByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `branch`: branch
   *
   * @return OK
   */
  getResourceByStackUsingGET(
    params: UiDropdownsControllerService.GetResourceByStackUsingGETParams,
  ): __Observable<BlueprintFile> {
    return this.getResourceByStackUsingGETResponse(params).pipe(
      __map((_r) => _r.body as BlueprintFile),
    );
  }

  /**
   * getAllVCS
   * @return OK
   */
  getAllVCSUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<string>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/dropdown/vcs`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getAllVCS
   * @return OK
   */
  getAllVCSUsingGET(): __Observable<Array<string>> {
    return this.getAllVCSUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getAzForRegionByCloud
   * @param params The `UiDropdownsControllerService.GetAzForRegionByCloudUsingGETParams` containing the following parameters:
   *
   * - `region`: region
   *
   * - `cloud`: cloud
   *
   * @return OK
   */
  getAzForRegionByCloudUsingGETResponse(
    params: UiDropdownsControllerService.GetAzForRegionByCloudUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.cloud),
        )}/region/${encodeURIComponent(
          String(params.region),
        )}/availability-zones`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getAzForRegionByCloud
   * @param params The `UiDropdownsControllerService.GetAzForRegionByCloudUsingGETParams` containing the following parameters:
   *
   * - `region`: region
   *
   * - `cloud`: cloud
   *
   * @return OK
   */
  getAzForRegionByCloudUsingGET(
    params: UiDropdownsControllerService.GetAzForRegionByCloudUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getAzForRegionByCloudUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<string>),
    );
  }

  /**
   * getRegions
   * @param cloud cloud
   * @return OK
   */
  getRegionsUsingGETResponse(
    cloud: string,
  ): __Observable<__StrictHttpResponse<Array<AllRegionsAndAZ>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(String(cloud))}/regions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AllRegionsAndAZ>>;
      }),
    );
  }
  /**
   * getRegions
   * @param cloud cloud
   * @return OK
   */
  getRegionsUsingGET(cloud: string): __Observable<Array<AllRegionsAndAZ>> {
    return this.getRegionsUsingGETResponse(cloud).pipe(
      __map((_r) => _r.body as Array<AllRegionsAndAZ>),
    );
  }

  /**
   * getRegionsV2
   * @param cloud cloud
   * @return OK
   */
  getRegionsV2UsingGETResponse(
    cloud: string,
  ): __Observable<__StrictHttpResponse<AllRegionsAndAZ>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(String(cloud))}/regions-v2`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AllRegionsAndAZ>;
      }),
    );
  }
  /**
   * getRegionsV2
   * @param cloud cloud
   * @return OK
   */
  getRegionsV2UsingGET(cloud: string): __Observable<AllRegionsAndAZ> {
    return this.getRegionsV2UsingGETResponse(cloud).pipe(
      __map((_r) => _r.body as AllRegionsAndAZ),
    );
  }

  /**
   * getLaunchDAG
   * @param params The `UiDropdownsControllerService.GetLaunchDAGUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `cloud`: cloud
   *
   * - `isProvidedK8s`: isProvidedK8s
   *
   * - `isDependent`: isDependent
   *
   * @return OK
   */
  getLaunchDAGUsingGETResponse(
    params: UiDropdownsControllerService.GetLaunchDAGUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<BlueprintFile>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.isProvidedK8s != null)
      __params = __params.set('isProvidedK8s', params.isProvidedK8s.toString());
    if (params.isDependent != null)
      __params = __params.set('isDependent', params.isDependent.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.clusterId),
        )}/cloud/${encodeURIComponent(String(params.cloud))}/launch-dag`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<BlueprintFile>>;
      }),
    );
  }
  /**
   * getLaunchDAG
   * @param params The `UiDropdownsControllerService.GetLaunchDAGUsingGETParams` containing the following parameters:
   *
   * - `clusterId`: clusterId
   *
   * - `cloud`: cloud
   *
   * - `isProvidedK8s`: isProvidedK8s
   *
   * - `isDependent`: isDependent
   *
   * @return OK
   */
  getLaunchDAGUsingGET(
    params: UiDropdownsControllerService.GetLaunchDAGUsingGETParams,
  ): __Observable<Array<BlueprintFile>> {
    return this.getLaunchDAGUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<BlueprintFile>),
    );
  }

  /**
   * getApplicationListByClusterIdAndResourceName
   * @param params The `UiDropdownsControllerService.GetApplicationListByClusterIdAndResourceNameUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getApplicationListByClusterIdAndResourceNameUsingGETResponse(
    params: UiDropdownsControllerService.GetApplicationListByClusterIdAndResourceNameUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<string>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.clusterId),
        )}/${encodeURIComponent(String(params.resourceType))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<string>>;
      }),
    );
  }
  /**
   * getApplicationListByClusterIdAndResourceName
   * @param params The `UiDropdownsControllerService.GetApplicationListByClusterIdAndResourceNameUsingGETParams` containing the following parameters:
   *
   * - `resourceType`: resourceType
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  getApplicationListByClusterIdAndResourceNameUsingGET(
    params: UiDropdownsControllerService.GetApplicationListByClusterIdAndResourceNameUsingGETParams,
  ): __Observable<Array<string>> {
    return this.getApplicationListByClusterIdAndResourceNameUsingGETResponse(
      params,
    ).pipe(__map((_r) => _r.body as Array<string>));
  }

  /**
   * getOutputReferences
   * @param params The `UiDropdownsControllerService.GetOutputReferencesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `outputType`: outputType
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getOutputReferencesUsingGETResponse(
    params: UiDropdownsControllerService.GetOutputReferencesUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<OutputReference>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.resourceType != null)
      __params = __params.set('resourceType', params.resourceType.toString());
    if (params.resourceName != null)
      __params = __params.set('resourceName', params.resourceName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.stackName),
        )}/output/${encodeURIComponent(String(params.outputType))}/references`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OutputReference>>;
      }),
    );
  }
  /**
   * getOutputReferences
   * @param params The `UiDropdownsControllerService.GetOutputReferencesUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `outputType`: outputType
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getOutputReferencesUsingGET(
    params: UiDropdownsControllerService.GetOutputReferencesUsingGETParams,
  ): __Observable<Array<OutputReference>> {
    return this.getOutputReferencesUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<OutputReference>),
    );
  }

  /**
   * getResourceHistoriesByStack
   * @param params The `UiDropdownsControllerService.GetResourceHistoriesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getResourceHistoriesByStackUsingGETResponse(
    params: UiDropdownsControllerService.GetResourceHistoriesByStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ResourceHistory>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/resource-history`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResourceHistory>>;
      }),
    );
  }
  /**
   * getResourceHistoriesByStack
   * @param params The `UiDropdownsControllerService.GetResourceHistoriesByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getResourceHistoriesByStackUsingGET(
    params: UiDropdownsControllerService.GetResourceHistoriesByStackUsingGETParams,
  ): __Observable<Array<ResourceHistory>> {
    return this.getResourceHistoriesByStackUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ResourceHistory>),
    );
  }

  /**
   * getResourceHistoryOverviewByStack
   * @param params The `UiDropdownsControllerService.GetResourceHistoryOverviewByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getResourceHistoryOverviewByStackUsingGETResponse(
    params: UiDropdownsControllerService.GetResourceHistoryOverviewByStackUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<ResourceHistoryOverview>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/dropdown/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/resource-history-overview`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResourceHistoryOverview>>;
      }),
    );
  }
  /**
   * getResourceHistoryOverviewByStack
   * @param params The `UiDropdownsControllerService.GetResourceHistoryOverviewByStackUsingGETParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getResourceHistoryOverviewByStackUsingGET(
    params: UiDropdownsControllerService.GetResourceHistoryOverviewByStackUsingGETParams,
  ): __Observable<Array<ResourceHistoryOverview>> {
    return this.getResourceHistoryOverviewByStackUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<ResourceHistoryOverview>),
    );
  }
}

module UiDropdownsControllerService {
  /**
   * Parameters for getAffectedResourcesByClusterUsingPOST
   */
  export interface GetAffectedResourcesByClusterUsingPOSTParams {
    /**
     * request
     */
    request: AffectedResourcesRequest;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getAllResourcesUsingGET
   */
  export interface GetAllResourcesUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * excludeSubstackResources
     */
    excludeSubstackResources?: boolean;
  }

  /**
   * Parameters for getAllResourcesByClusterUsingGET
   */
  export interface GetAllResourcesByClusterUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * includeSubstack
     */
    includeSubstack?: boolean;

    /**
     * includeContent
     */
    includeContent?: boolean;

    /**
     * excludeAddOns
     */
    excludeAddOns?: boolean;
  }

  /**
   * Parameters for getResourceByClusterIdUsingGET
   */
  export interface GetResourceByClusterIdUsingGETParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * clusterId
     */
    clusterId: string;

    /**
     * includeContent
     */
    includeContent?: boolean;
  }

  /**
   * Parameters for getFileFromFacetsModulesUsingGET
   */
  export interface GetFileFromFacetsModulesUsingGETParams {
    /**
     * path
     */
    path: string;

    /**
     * fileName
     */
    fileName: string;
  }

  /**
   * Parameters for syncClusterHistoryUsingPOST
   */
  export interface SyncClusterHistoryUsingPOSTParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * force
     */
    force?: boolean;
  }

  /**
   * Parameters for getGitHistoryForResourceUsingGET
   */
  export interface GetGitHistoryForResourceUsingGETParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for syncSubstackGitHistoryUsingPOST
   */
  export interface SyncSubstackGitHistoryUsingPOSTParams {
    /**
     * substackName
     */
    substackName: string;

    /**
     * forceSync
     */
    forceSync: boolean;
  }

  /**
   * Parameters for getAffectedResourcesByStackUsingPOST
   */
  export interface GetAffectedResourcesByStackUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * request
     */
    request: AffectedResourcesRequest;
  }

  /**
   * Parameters for getAllResourcesForAllClusterOfStackUsingGET
   */
  export interface GetAllResourcesForAllClusterOfStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * excludeAddOns
     */
    excludeAddOns?: boolean;
  }

  /**
   * Parameters for getAllResourcesByStackUsingGET
   */
  export interface GetAllResourcesByStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * includeContent
     */
    includeContent?: boolean;

    /**
     * excludeAddOns
     */
    excludeAddOns?: boolean;

    /**
     * branch
     */
    branch?: string;
  }

  /**
   * Parameters for getServiceOverviewUsingGET
   */
  export interface GetServiceOverviewUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * serviceName
     */
    serviceName: string;
  }

  /**
   * Parameters for getAllClusterResourcesByStackUsingGET
   */
  export interface GetAllClusterResourcesByStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }

  /**
   * Parameters for getResourceByStackUsingGET
   */
  export interface GetResourceByStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * branch
     */
    branch?: string;
  }

  /**
   * Parameters for getAzForRegionByCloudUsingGET
   */
  export interface GetAzForRegionByCloudUsingGETParams {
    /**
     * region
     */
    region: string;

    /**
     * cloud
     */
    cloud: string;
  }

  /**
   * Parameters for getLaunchDAGUsingGET
   */
  export interface GetLaunchDAGUsingGETParams {
    /**
     * clusterId
     */
    clusterId: string;

    /**
     * cloud
     */
    cloud: 'AWS' | 'AZURE' | 'LOCAL' | 'GCP' | 'KUBERNETES' | 'NO_CLOUD';

    /**
     * isProvidedK8s
     */
    isProvidedK8s?: boolean;

    /**
     * isDependent
     */
    isDependent?: boolean;
  }

  /**
   * Parameters for getApplicationListByClusterIdAndResourceNameUsingGET
   */
  export interface GetApplicationListByClusterIdAndResourceNameUsingGETParams {
    /**
     * resourceType
     */
    resourceType: string;

    /**
     * clusterId
     */
    clusterId: string;
  }

  /**
   * Parameters for getOutputReferencesUsingGET
   */
  export interface GetOutputReferencesUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * outputType
     */
    outputType: string;

    /**
     * resourceType
     */
    resourceType?: string;

    /**
     * resourceName
     */
    resourceName?: string;
  }

  /**
   * Parameters for getResourceHistoriesByStackUsingGET
   */
  export interface GetResourceHistoriesByStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }

  /**
   * Parameters for getResourceHistoryOverviewByStackUsingGET
   */
  export interface GetResourceHistoryOverviewByStackUsingGETParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }
}

export { UiDropdownsControllerService };
